export const payMethods = {
  1: 'Cartão de Crédito', 2: 'Cartão de Débito', 3: 'DOC/TED', 4: 'Outros'
}

export const payMethodsList = [
  { value: '1', description: 'Cartão de Crédito' },
  { value: '2', description: 'Cartão de Débito' }, 
  { value: '3', description: 'DOC/TED' },
  { value: '4', description: 'Outros' }
]

export const states = {
  1: 'OK', 2: 'Aguard Cancel AMC', 3: 'Aguard Estorno', 4: 'Estornado'
}

export const types = {
  1: 'UNLOCK', 2: 'ACTIVATION', 3: 'UNLOCK_ACTIVATION', 4: 'CANCELLATION', 5: 'CANCEL_ACTIVATION'
}

export const vehicleTypes = { 
  1: 'CAR', 2: 'BUS / TRUCK' 
}

export const recipients = [
  { value: 'all', description: 'Todos' },
  { value: 'app', description: 'App' },
  { value: 'pdv', description: 'PDV' },
  { value: 'specific', description: 'Específico' },
  { value: 'default', description: 'Padrão' },
];

export const searchTypes = [
  { value: 'cpf_cnpj', description: 'CPF ou CNPJ', pattern: '(^[0-9]{3}[.][0-9]{3}[.][0-9]{3}[-][0-9]{2}$)|(^[0-9]{2}[.][0-9]{3}[.][0-9]{3}[/][0-9]{4}[-][0-9]{2}$)', title: '123.123.123-12 para CPF ou 12.123.123/0001-12 para CNPJ' },
  { value: 'email', description: 'EMAIL', pattern: '.{3,40}', title: 'nome@email.com' },
  { value: 'name', description: 'NOME', pattern: '.{3,20}', title: 'Nome de no mínimo 3 letras' },
];

